import { render } from "./AlertOutline.vue?vue&type=template&id=a502a048"
import script from "./AlertOutline.vue?vue&type=script&lang=js"
export * from "./AlertOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__